import { render, staticRenderFns } from "./CoastsAlertsBody.vue?vue&type=template&id=ba0fa74e&scoped=true"
import script from "./CoastsAlertsBody.vue?vue&type=script&lang=js"
export * from "./CoastsAlertsBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0fa74e",
  null
  
)

export default component.exports